import { InitReservatioOrders } from "./reservatio/orders/ReservatioOrders";
import { InitReservatioPlaces } from "./reservatio/places/ReservatioPlaces";
import { InitReservatioServices } from "./reservatio/services/ReservatioServices";
import { InitReservatioSettings } from "./reservatio/settings/ReservatioSettings";
import { InitCreateOrder } from "./reservatio/orders/CreateOrder";
import { InitGallery } from "./reservatio/settings/Gallery";
import { InitOrderCheck } from "./simplepay/OrderCheck";

class Main{
    constructor(){
        new InitReservatioPlaces();
        new InitReservatioServices();
        new InitReservatioSettings();
        new InitReservatioOrders();
        new InitCreateOrder();
        new InitGallery();
        new InitOrderCheck();
    }
}
new Main();